<div class="admin-shell" *ngIf="userRole">
  <header class="admin-topbar" [style.background-color]="headerColor">
    <button
      #menuButton
      mat-icon-button
      type="button"
      class="admin-menu-button"
      [attr.aria-expanded]="menuOpen"
      aria-controls="adminMenu"
      [attr.aria-label]="menuOpen ? 'Close admin menu' : 'Open admin menu'"
      (click)="toggleMenu()"
    >
      <mat-icon>menu</mat-icon>
    </button>
    <span class="admin-brand">ADMIN</span>
    <span class="admin-crumb" *ngIf="currentLabel">{{ currentLabel }}</span>
  </header>

  <div class="admin-body">
    <button
      class="admin-backdrop"
      type="button"
      *ngIf="menuOpen"
      aria-label="Close admin menu"
      (click)="closeMenu()"
    ></button>

    <nav
      id="adminMenu"
      class="admin-drawer"
      [class.open]="menuOpen"
      aria-label="Admin"
    >
      <section class="admin-group" *ngFor="let group of navGroups">
        <div class="admin-group-title">{{ group.title }}</div>
        <a
          *ngFor="let link of group.links"
          [routerLink]="[{ outlets: { sub: [link.path] } }]"
          routerLinkActive="active"
          [class.active]="isActive(link.path)"
          (click)="closeMenu()"
        >
          {{ link.label }}
        </a>
      </section>
    </nav>

    <div class="admin-choose" *ngIf="!currentLabel">
      <h2>ADMIN</h2>
      <p>Choose a section from the menu.</p>
    </div>
    <router-outlet name="sub"></router-outlet>
  </div>
</div>
